import { Button, Grid } from '@deere/fuel-react';
import { Form, Col, Row} from '@deere/ux.uxframe-react'
import React from 'react';
import { useTranslation } from "react-i18next";
import { SCBM_STATES_CAMPAIGN, SCBM_USER_TYPE } from '../../utils/surveyLiterals';
import { useUserInfo } from '../../providers/userProvider'

function disableSubmitButtons(campaign, userInfo) {
    const deereUser = userInfo && userInfo.userType === SCBM_USER_TYPE.SALARY;
    return campaign.status === SCBM_STATES_CAMPAIGN.CLOSED || deereUser;
}


export default function ActionsCOOReviewSurvey({ setshowAgreement, cooResponse, campaign, backToEdit, survey }) {
    const { t } = useTranslation();
    const userInfo = useUserInfo();

    return (<>
    <Row className="card position-sticky fixed-bottom d-print-none">
    <Row className="card position-sticky fixed-bottom">
    <Col md="24" className="card-body p-3 text-right">
    <Form.Group as={Col} className="align-right"> 
        <Grid container justifyContent={"flex-end"}>
                <Button variant="secondary" className="float-right mr-2" onClick={backToEdit} >{t('btn_review_back_to_edit')}</Button>
                <Button variant="primary" className="float-right mr-2" onClick={()=>setshowAgreement(true)} disabled={disableSubmitButtons(campaign, userInfo)}>{t('btn_review_submit')}</Button>
        </Grid>
        </Form.Group>
                    </Col>
      </Row>
      </Row>
    </>)
}   